/**
 * Get standardized color for a segment name
 * @param segmentName The name of the segment
 * @returns The color hex code for the segment
 */
export const getSegmentColor = (segmentName: string | null | undefined): string => {
  if (!segmentName) return '#3174ad'; // default blue
  
  const name = segmentName.toLowerCase();
  switch (name) {
    case 'newsletter':
      return '#3b82f6'; // blue
    case 'luxury':
      return '#9333ea'; // purple
    case 'romance':
      return '#ec4899'; // pink
    case 'family':
      return '#22c55e'; // green
    case 'ultralux':
      return '#f59e0b'; // amber
    case 'adventure':
      return '#673ab7'; // deep purple
    case 'beach':
      return '#03a9f4'; // light blue
    case 'city':
      return '#2196f3'; // blue
    case 'cruise':
      return '#00bcd4'; // cyan
    case 'culture':
      return '#009688'; // teal
    case 'food':
      return '#4caf50'; // green
    case 'unsubscribed':
      return '#9ca3af'; // light grey
    default:
      return '#3174ad'; // default blue
  }
}; 